
// react-bootstrap imports
import { useNavigate } from "react-router-dom"
import { OverlayTrigger, Tooltip} from "react-bootstrap"
import { Button, Card, Col, Row, Stack } from "react-bootstrap"

// components imports
import { userLogado, userHasAccess, userData } from "services/LoginFunctions"

import * as Links from "constants/links"

// assets imports
import card_simtaxa from "assets/card_calcTaxa.png"
import card_calcTaxaNovo from "assets/card_calcTaxaNovo.png"
import card_meusTestes from "assets/card_meusTestes.png"
import card_processos from "assets/card_processos.png"

import { ROLE } from "constants/userRoles"

const atualizacoes = 
[
    '1. Adição da Certidão de Demolição, Certidão de Regularização de Loteamento e TVO',
    '2. Adição do nome do analista na guia e remoção do n° da guia',
    '3. Correção do documento gerado pela Renovação de Alvará',
    '4. Formatação das áreas no pdf para 2 casas decimais com m²'
]

const decorationImg = null

const CustomCard = ({ imgSRC, linkText, linkdestiny, buttonOverlayMessage, loginReq, stateDestiny }) =>
{
    const navigate = useNavigate()

    const overlayMessage = buttonOverlayMessage !== undefined ? <Tooltip variant="primary" > {buttonOverlayMessage} </Tooltip> : <></>

    function redirect()
    {
        if (!loginReq || userLogado)
        {
            navigate(linkdestiny, {state: stateDestiny})
        }
    }

    return (
        <Card style={{width: "18rem"}}>
            <Card.Body className="justify-content-center d-grid gap-3 shadow">
                <img src={imgSRC} className="m-auto" alt="logo" />
                <OverlayTrigger placement="top" delay={{ show: 250, hide: 250 }} overlay={overlayMessage}>
                    <Button className="btn btn-primary shadow rounded-3" onClick={redirect} >{linkText}</Button>
                </OverlayTrigger>
            </Card.Body>
        </Card>
    )
}

const Cards = () =>
{
    const calcTaxasMessage = "Opa! Lembre-se que partir de 01/04/2024 todas as taxas devem ser calculadas pelo método do novo CTM (botão ao lado)"

    return (
        <Stack direction="horizontal" className="justify-content-center">
            <Row>
                <Col>
                    <CustomCard imgSRC={card_simtaxa} linkText={"Calculadora de taxas"} linkdestiny={Links.SERVICOS_TAXAS_LEGADO} buttonOverlayMessage={calcTaxasMessage} loginReq={false} />
                </Col>
                <Col>
                    <CustomCard imgSRC={card_calcTaxaNovo} linkText={"Calculadora de taxas CTM 2024"} linkdestiny={Links.SERVICOS_TAXAS_CTM24} loginReq={false} />
                </Col>
                {
                    userHasAccess(ROLE.TESTER) ?
                    <>
                        <Col>
                            <CustomCard imgSRC={card_meusTestes} linkText={"Realizar testes"} linkdestiny={Links.TESTES} loginReq={false} />
                        </Col>
                    </>
                    :
                    <></>
                }
                {
                    <>
                        {/* <Col>
                            <CustomCard imgSRC={card_processos} linkText={"Iniciar processo"} linkdestiny={Links.INICIAR_OU_CONTINUAR_PROCESSO} loginReq={false} />
                        </Col> */}
                        <Col>
                            <CustomCard imgSRC={card_processos} linkText={"Gerar documento"} linkdestiny={Links.ESCOLHA_SUA_GUIA} loginReq={false} />
                        </Col>
                    </>
                }
                {
                    userData().matricula === "005877" ?
                    <>
                        <Col>
                            <CustomCard imgSRC={card_processos} linkText={"Gerar documento interno"} linkdestiny={Links.GERAR_DOCUMENTO} loginReq={false}
                            stateDestiny={{ idServ: "DirDrenagem", dadosDoc: {tipoDoc: "DirDrenagem", subTipoDoc: null}, statePrevPage: undefined, linkPrevPage: Links.HOME }}
                             />
                        </Col>
                    </>
                    :
                    <></>
                }
            </Row>
        </Stack>
    )
}

const Comunicado = () =>
{
    // <hr />
    //         <h6 className="text-center fw-bold">Lembrete:{" "}</h6>
    //         <hr />
    return (
        <div className="mb-4">
            
        </div>
    )
}

const UltimasAtualizacoes = () =>
{
    return (
        <div className="mb-4">
            <h6 className="text-center fw-bold d-inline">Últimas atualizações:{" "}</h6>
            {atualizacoes.map(att => <div key={att}><h6 className="text-center d-inline" >{att}{" "}</h6><br /></div>)}
        </div>
    )
}
export default function HomeScreen()
{
    const versao = process.env.REACT_APP_VERSION
    return (
        <div className="container text-center my-auto mb-4" style={{backgroundImage: "url(" + decorationImg + ")",  backgroundRepeat: "no-repeat", backgroundPosition: "center"}}>
            <h1 className="text-primary fs-1 mb-3 text-shadow">EMURB DC</h1>
            <h2 className="fs-5 mb-4">Serviços automatizados da EMURB</h2>
            <UltimasAtualizacoes />
            <Comunicado />
            <Cards />
            <div className="d-flex justify-content-center align-items-center position-relative" >
                <p className="fw-bold mt-3 fs-5">{"Versão "}{versao}</p>
            </div>
        </div>
    )
}